import { api } from './client';
import type { Page } from './catalogs';

/** ч.1209: наказ про тривалу відсутність працівника. Працівник лишається у штаті,
 *  зарплата не нараховується; проведений наказ враховують табель, нарахування,
 *  середня зарплата, дні відпустки, обʼєднана звітність і звіт про внесок. */
export type AbsenceKind = 'CHILDCARE' | 'MILITARY' | 'SUSPENDED';
export type ChildcareAgeGroup = 'UNDER_3' | 'FROM_3_TO_6';

export interface AbsenceOrder {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  employee_id: string;
  absence_kind: AbsenceKind;
  childcare_age_group: ChildcareAgeGroup | null;
  start_date: string;
  end_date: string | null;
  basis: string | null;
  comment: string | null;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  external_source?: string | null;
  created_at: string;
}

export interface AbsenceOrderCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  employee_id: string;
  absence_kind: AbsenceKind;
  childcare_age_group?: ChildcareAgeGroup | null;
  start_date: string;
  end_date?: string | null;
  basis?: string | null;
  comment?: string | null;
}

export const ABSENCE_KIND_LABELS: Record<AbsenceKind, string> = {
  CHILDCARE: 'Відпустка для догляду за дитиною',
  MILITARY: 'Військова служба (мобілізація, контракт)',
  SUSPENDED: 'Призупинення дії трудового договору',
};
export const CHILDCARE_AGE_LABELS: Record<ChildcareAgeGroup, string> = {
  UNDER_3: 'до досягнення дитиною 3 років',
  FROM_3_TO_6: 'від 3 до 6 років (за медичним висновком)',
};

/** «відпустка для догляду за дитиною з 10.06.2026 по 09.06.2029» — для картки і підказок. */
export function describeAbsence(kind: string, from: string, to?: string | null): string {
  const d = (s: string) => s.slice(0, 10).split('-').reverse().join('.');
  const label = (ABSENCE_KIND_LABELS as Record<string, string>)[kind] ?? kind;
  return `${label.charAt(0).toLowerCase()}${label.slice(1)} з ${d(from)}${to ? ` по ${d(to)}` : ''}`;
}

const BASE = '/absence-orders';

export const absenceOrders = {
  list: (params?: { organization_id?: string; employee_id?: string; posted?: boolean; limit?: number }) =>
    api.get<Page<AbsenceOrder>>(BASE, { params }).then((r) => r.data),
  get: (id: string) => api.get<AbsenceOrder>(`${BASE}/${id}`).then((r) => r.data),
  create: (p: AbsenceOrderCreate) => api.post<AbsenceOrder>(BASE, p).then((r) => r.data),
  update: (id: string, p: Partial<Omit<AbsenceOrderCreate, 'organization_id'>>) =>
    api.patch<AbsenceOrder>(`${BASE}/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`${BASE}/${id}`).then(() => undefined),
  post: (id: string) => api.post<AbsenceOrder>(`${BASE}/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post<AbsenceOrder>(`${BASE}/${id}/unpost`).then((r) => r.data),
};
